module.exports = __webpack_public_path__ + "static/img/products_roof_mobile.8929ad06.jpg";